"use strict";

/* eslint-disable no-unsafe-finally */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encodeSettingsValue = encodeSettingsValue;
exports.decodeSettingsValue = decodeSettingsValue;
exports.MAX_DATA_LENGTH = void 0;

var _ = require("_");

var _immutable = require("immutable");

/**
 * The backend enforces a character limit each value.
 */
var MAX_DATA_LENGTH = 1000;
exports.MAX_DATA_LENGTH = MAX_DATA_LENGTH;

function encodeSettingsValue(value) {
  try {
    // Did you know? Immutable objects support being stringified.
    value = JSON.stringify(value);
  } finally {
    var length = (0, _.isString)(value) ? value.length : 0;

    if (length > MAX_DATA_LENGTH) {
      var error = new Error("Expected encodedValue.length to be less than " + MAX_DATA_LENGTH);
      throw error;
    }

    return value;
  }
}

function decodeSettingsValue(value) {
  if (value === null || value === undefined || typeof value === 'undefined') {
    return null;
  } else if (value === 'undefined') {
    return 'undefined';
  }

  try {
    value = JSON.parse(value);
  } finally {
    return (0, _immutable.fromJS)(value);
  }
}